/**
 * mwApp.settings module <br>
 * Work with settings
 *
 * @namespace mwApp/settings
 */

import { disallowValues } from './settings.directives'
import AddCashPaymentServiceCtrl from './addCashPaymentService.controller'
import AddCurrencyCtrl from './addCurrency.controller'
import AddDeviceRedirectCtrl from './addDeviceRedirect.controller'
import AddExternalUserCtrl from './addExternalUser.controller'
import AddExternalPaymentServiceCtrl from './addExternalPaymentService.controller'
import AddPaymentServiceCtrl from './addPaymentService.controller'
import AddPermissionRuleCtrl from './addPermissionRule.controller'
import AddPlaybackTokenGeneratorCtrl from './addPlaybackTokenGeneratorCtrl.controller'
import AddSystemUserCtrl from './addSystemUser.controller'
import ExtensionsCtrl from './extensions.controller'
import ExternalUsersCtrl from './externalUsers.controller'
import GeneralSettingsCtrl from './generalSettings.controller'
import GeoPolicyCtrl from './geoPolicy.controller'
import PaymentSystemCtrl from './paymentSystem.controller'
import SystemUsersCtrl from './systemUsers.controller'
import AddCurrencyConverterCtrl from './addCurrencyConverter.controller'
import settingsConfig from './settings.config'
import AddCountryListCtrl from './addCountryList.controller'
import PopupCtrl from '../common/popup.controller'
import AppsSettingsCtrl from './appsSettings.controller'
import ProductTourCtrl from './productTour.controller'
import ProductTourAddSlideCtrl from './productTourAddSlide.controller'
import AddTemplateVariableCtrl from './addTemplateVariable.controller'

export default
angular.module('mwApp.settings', [])
  .config(settingsConfig)
  .directive('disallowValues', disallowValues)
  .controller('GeneralSettingsCtrl', GeneralSettingsCtrl)
  .controller('GeoPolicyCtrl', GeoPolicyCtrl)
  .controller('SystemUsersCtrl', SystemUsersCtrl)
  .controller('AddSystemUserCtrl', AddSystemUserCtrl)
  .controller('AddPermissionRuleCtrl', AddPermissionRuleCtrl)
  .controller('ExtensionsCtrl', ExtensionsCtrl)
  .controller('AppsSettingsCtrl', AppsSettingsCtrl)
  .controller('ProductTourCtrl', ProductTourCtrl)
  .controller('ProductTourAddSlideCtrl', ProductTourAddSlideCtrl)
  .controller('ExternalUsersCtrl', ExternalUsersCtrl)
  .controller('AddCashPaymentServiceCtrl', AddCashPaymentServiceCtrl)
  .controller('AddDeviceRedirectCtrl', AddDeviceRedirectCtrl)
  .controller('AddPlaybackTokenGeneratorCtrl', AddPlaybackTokenGeneratorCtrl)
  .controller('AddTemplateVariableCtrl', AddTemplateVariableCtrl)
  .controller('PaymentSystemCtrl', PaymentSystemCtrl)
  .controller('AddPaymentServiceCtrl', AddPaymentServiceCtrl)
  .controller('AddCurrencyCtrl', AddCurrencyCtrl)
  .controller('AddExternalUserCtrl', AddExternalUserCtrl)
  .controller('AddExternalPaymentServiceCtrl', AddExternalPaymentServiceCtrl)
  .controller('AddCurrencyConverterCtrl', AddCurrencyConverterCtrl)
  .controller('AddCountryListCtrl', AddCountryListCtrl)
  .controller('PopupCtrl', PopupCtrl)
